import { LogManager, InternalServerErrorException } from '../../../common';
import { GetUserWorkingSessionsApplicationService } from '../../../core/application/services/working-sessions/get-user-working-sessions.application-service';
import { OrgWorkingSessionsEntity } from '../../../core/domain/entities/working-sessions/org-working-sessions.entity';
import { SelfWorkingSessionsEntity } from '../../../core/domain/entities/working-sessions/self-working-sessions.entity';
import { GetUserWorkingSessionsRequestDto } from '../../dtos/working-sessions/user/get-user-working-sessions.request.dto';

export class GetUserWorkingSessionsQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetUserWorkingSessionsApplicationService
  ) {}
  async execute(
    props: GetUserWorkingSessionsRequestDto
  ): Promise<OrgWorkingSessionsEntity[]> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new InternalServerErrorException(error);
    }
  }
}
